import './footer.less'

import {Image} from '@codeurs/front'
import imecLogo40yearsWhite from 'assets/images/imec-logo-40years-white.svg'
import {EventModel} from 'models/EventModel'
import React from 'react'
import {LinkType} from 'types'
import {useIsDark} from 'util/hooks'
import {Link} from 'util/link'
import {scrollTo} from 'util/scrollmemory'
import {style} from 'util/style'
import {EventLogo} from 'views/layout/eventlogo'
import {Theme} from 'views/theme'
import {Sociallink} from './sociallink'

// import imecLogoWhite from 'assets/images/imec-logo-white.svg'
// import imecLogo from 'assets/images/imec-logo.svg'

const styles = style('footer', ['follow', 'link'])

export type FooterType = {
	row1_title: string
	row1_links: Array<LinkType>
	row2_title: string
	row2_links: Array<LinkType>
	cta?: LinkType
} & FooterFollowType

export type FooterFollowType = {
	instagram: string
	linkedin: string
	facebook: string
	twitter: string
}

export const Footer: React.FC<{pageurl?: string; event: EventModel}> = ({
	pageurl,
	event
}) => {
	const isDark = useIsDark()
	const {
		instagram,
		linkedin,
		facebook,
		twitter,
		row1_title,
		row1_links,
		row2_title,
		row2_links
	} = event.footer

	return (
		<div className={styles()}>
			<Theme.OuterContainer>
				<Theme.Container>
					<div className={styles('row')}>
						<div className={styles('col')}>
							<EventLogo event={event} mod="footer" />
							<FooterFollow
								instagram={instagram}
								linkedin={linkedin}
								facebook={facebook}
								twitter={twitter}
							/>
						</div>
						<div className={styles('col')}>
							{row1_title && (
								<h3 className={styles('col-title')}>{row1_title}</h3>
							)}
							{row1_links.map(link => (
								<FooterLink pageurl={pageurl} {...link} />
							))}
						</div>
						<div className={styles('col')}>
							{row2_title && (
								<h3 className={styles('col-title')}>{row2_title}</h3>
							)}
							{row2_links.map(link => (
								<FooterLink pageurl={pageurl} {...link} />
							))}
						</div>
						<div className={styles('col')}></div>
					</div>
					<div className={styles('imec')}>
						<Link
							to="https://www.imec-int.com"
							target="_blank"
							className={styles('imec-logo')}
							title="imec corporate website"
						>
							{/* <Image {...(isDark ? imecLogoWhite : imecLogo)} alt="imec logo" /> */}
							<Image
								{...(isDark ? imecLogo40yearsWhite : imecLogo40yearsWhite)}
								alt="imec logo"
							/>
						</Link>
					</div>
				</Theme.Container>
			</Theme.OuterContainer>
		</div>
	)
}

export const FooterFollow: React.FC<FooterFollowType> = ({
	instagram,
	linkedin,
	facebook,
	twitter
}) => {
	if (!instagram && !linkedin && !facebook && !twitter) return null

	return (
		<div class={styles.follow()}>
			<div class={styles.follow('social')}>
				{instagram && <Sociallink type={'Instagram'} url={instagram} />}
				{linkedin && <Sociallink type={'LinkedIn'} url={linkedin} />}
				{facebook && <Sociallink type={'Facebook'} url={facebook} />}
				{twitter && <Sociallink type={'Twitter'} url={twitter} />}
			</div>
		</div>
	)
}

export const FooterLink: React.FC<{pageurl?: string} & LinkType> = ({
	pageurl,
	url,
	title,
	description
}) => {
	if (pageurl === url)
		return (
			<div className={styles.link()}>
				<a
					onClick={() => scrollTo(() => 0, 0, true)}
					className={styles.link('text')}
				>
					{description || title}
				</a>
			</div>
		)

	return (
		<div className={styles.link()}>
			<Link to={url} className={styles.link('text')}>
				{description || title}
			</Link>
		</div>
	)
}
